import styled from 'styled-components';

import { namedBreakpoints } from 'theme';

export const HeroBackgroundContainer = styled.div`
  position: absolute;
  transform: translateZ(0);
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const HeroBackgroundImageContainer = styled.div<{
  $hasMobileImage: boolean;
}>`
  width: 100%;
  height: 100%;

  ${(props) =>
    props.$hasMobileImage &&
    `
      @media (max-width: ${namedBreakpoints.mdDown}) {
        display: none;
      }
  `}
`;

export const HeroBackgroundMobileImageContainer = styled.div`
  width: 100%;
  height: 100%;

  @media (min-width: ${namedBreakpoints.mdUp}) {
    display: none;
  }
`;
